import db from './dbConfig';
import { loadStripe } from '@stripe/stripe-js';
import firebase from './config';
import 'firebase/functions'

export async function createCheckoutSession(uid) {
  // const product = await db.collection('products').get().then((docs) => {
  //   return docs.docs[0].id
  // })
  // const price = await db.collection('products').doc(product).collection('prices').get().then((docs) => {
  //   return docs.docs[0].id
  // })

  const price = 'price_1IFhbEB882JN9v0uVFvV06Qn'

  const checkoutSessionRef = await db
    .collection('users')
    .doc(uid)
    .collection('checkout_sessions')
    .add({
      price: price,
      allow_promotion_codes: true,
      success_url: `${window.location.origin}/profile`,
      cancel_url: `${window.location.origin}/upgrade`,
      mode: 'subscription'
    });

  checkoutSessionRef.onSnapshot(async (snap) => {
    const { sessionId } = snap.data();
    if (sessionId) {
      const stripe = await loadStripe('pk_live_51I8a8vB882JN9v0u3rzdiOtcMtFf9uDEswAJG8PWYcnqBBoK3NwtfsjFAkqhE97fXleVp9i5O7c3J17pshoCg7LE00jAVJqiSw');//Chave Pública
      stripe.redirectToCheckout({ sessionId });
    }
  });
}

const app = firebase.app()
export async function goToBillingPortal() {
  const functionRef = app.functions().httpsCallable('ext-firestore-stripe-subscriptions-createPortalLink')
  const { data } = await functionRef({
    returnUrl: `${window.location.origin}/profile`,
  })
  window.location.assign(data.url)
}

export async function hasSubscriptions(uid){
  var subscriptions = false;
  const snapshot = await db.collection('users').doc(uid).collection('subscriptions').where('status', 'in', ['trialing', 'active', 'cortesy']).get()
  if(!snapshot.empty){
    subscriptions = true;
  } else {
    subscriptions = false;
  }
    return subscriptions
}
